import { useState, useEffect } from 'react';
import { Radio } from '@components';

type FilterProps = {
    meta: any;
    header: any;
    filterData: any;
    onChange: (val: any) => void;
}

type RadioOpt = {
	value: string;
	label: string;
	checked: boolean;
}

export const FilterRadio = (props: FilterProps) => {
	const {
		meta,
		header,
		filterData,
		onChange
	} = props;
	const [selectVal, setSelectVal] = useState('');
	const [selectOptions, setSelectOptions] = useState<RadioOpt[]>([]);
	const filterOptions = meta?.filterOptions?.options ?? [];
	const updateVal = (value: string) => {
		setSelectVal(value);
		const newFilterData = { ...filterData };
		newFilterData.value = value;
		newFilterData.columnField = meta?.databaseLocation ?? header;
		newFilterData.operatorValue = 'is';
		onChange(newFilterData);
	}
	const generateSelectOptions = (options: { value: string; label: string }[]): RadioOpt[] => {
		const opts = options.map((opt) => {
			return {
				value: opt.value,
				label: opt.label,
				checked: selectVal === opt.value
			}
		});

		return opts;
	}

	useEffect(() => {
		setSelectOptions(generateSelectOptions(filterOptions));
	}, [selectVal, meta]);

	useEffect(() => {
		if (filterData?.value) {
			setSelectVal(`${filterData.value}` || '');
		} else {
			setSelectVal('');
		}
	}, [filterData]);

	return (
		<div>
			<Radio.Group>
				{selectOptions.map((opt, i) => {
					return <Radio
						key={i}
						name={''}
						label={opt.label}
						value={opt.value}
						onChange={(e) => updateVal(e.target.value)}
						checked={opt.checked}
					/>
				})}
			</Radio.Group>
		</div>
	);
}
